import React, { useCallback, useEffect } from 'react'

import { connect, useDispatch } from 'react-redux'

import { getAvailableBoxSizes } from 'actions/basket'
import { trackDiscountVisibilityBannerAppearance } from 'actions/tracking'
import { useIsSignupMotivationsEnabled } from 'hooks/useIsSignupMotivationsEnabled'
import {
  signupDismissDiscountAppliedBar,
  signupNextStep,
  signupSetStep,
  signupStepsReceive,
} from 'routes/Signup/signupActions'

import { useDiscountAppliedData } from '../../components/DiscountAppliedBar/discountAppliedBarHooks'
import { Signup } from './Signup'
import { useSignupMotivations } from './hooks/useSignupMotivations'

const mapStateToProps = (state, ownProps) => ({
  secondarySlug: ownProps.params.secondarySlug,
  stepNames: state.signup.getIn(['wizard', 'stepNames']),
  orderDiscount: state.promoStore[state.promoCurrent]?.details?.['discount-whole-order-percent'],
  promoModalVisible: state.promoModalVisible,
  isDiscountAppliedBarDismissed: state.signup.get('isDiscountAppliedBarDismissed'),
})

const SignupPure = (props) => {
  const dispatch = useDispatch()
  const { isDiscountEnabled, discountAppliedTitle, discountAppliedBody, discountAmount } =
    useDiscountAppliedData()
  const isMotivationsEnabled = useIsSignupMotivationsEnabled()
  const trackDiscountVisibility = useCallback(
    (wizardStep) => trackDiscountVisibilityBannerAppearance(wizardStep),
    [],
  )
  const { motivations, error, loading } = useSignupMotivations()
  const isSignupMotivationsEnabled = !error && isMotivationsEnabled
  useEffect(() => {
    const fetchAvailableBoxSizes = async () => {
      await dispatch(getAvailableBoxSizes())
    }
    fetchAvailableBoxSizes()
  }, [dispatch])

  if (loading) {
    return null
  }

  return (
    <Signup
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      isDiscountEnabled={isDiscountEnabled}
      isSignupMotivationsEnabled={isSignupMotivationsEnabled}
      discountAmount={discountAmount}
      discountAppliedTitle={discountAppliedTitle}
      discountAppliedBody={discountAppliedBody}
      trackDiscountVisibility={trackDiscountVisibility}
      motivations={motivations}
    />
  )
}

const SignupContainer = connect(mapStateToProps, {
  goToStep: signupNextStep,
  signupStepsReceive,
  signupDismissDiscountAppliedBar,
  signupSetStep,
})(SignupPure)

export { SignupContainer }
